module.exports = __webpack_public_path__ + "static/media/Difficulty.662474b4.svg";